module.exports = __webpack_public_path__ + "static/media/Man.1d93f58e.png";